export const styles = {
  container: 'tw-w-full tw-flex tw-items-center tw-gap-4 tw-mb-4',
};
